<template>
  <div>
    <ml-table
      :pagination="false"
      :columns="columns"
      :dataSource="dataSource"
      bordered
      :loading="loading"
      :scroll="{ y: 300, x: 2700 }"
    >
      <template slot="batchCode" slot-scope="text, record">
        <div>
          <a-input
            v-if="record.editable && !tableDef.hasOutOrder"
            :value="text"
            :placeholder="
              $t('common_please_input') + $t('page_material_warehousing_material_batch')
            "
            @change="(e) => handleChange(e.target.value, record, 'batchCode')"
          />
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
      <template slot="barCode" slot-scope="text, record">
        <div>
          <a-select
            style="width:100%"
            v-if="record.editable && !tableDef.hasOutOrder && !tableDef.isPlan"
            showSearch
            :placeholder="$t('please_select') + $t('page_material_warehousing_material_bar')"
            :dropdownMatchSelectWidth="false"
            :filterOption="false"
            :value="record.displayCode"
            @dropdownVisibleChange="() => getALLMaterial()"
            @search="(value) => changeMaterialList(value)"
            @change="(value) => changeMaterial(value, record)"
          >
            <template v-for="(item, index) in materialList">
              <a-select-option :key="index" :value="item.displayCode">
                {{ item.displayCode }}
              </a-select-option>
            </template>
          </a-select>
          <template v-else>
            {{ record.barCode }}
          </template>
        </div>
      </template>
      <template slot="totalNum" slot-scope="text, record">
        <div>
          <a-input-number
            :min="0"
            v-if="record.editable && !tableDef.hasOutOrder"
            :max="999999999"
            :value="text"
            @change="(e) => handleChange(e, record, 'totalNum')"
          />
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
      <template slot="stockInNum" slot-scope="text, record">
        <div>
          <a-input-number
            :min="0"
            v-if="record.editable"
            :max="999999999"
            :value="text"
            @change="(e) => handleChange(e, record, 'stockInNum')"
          />
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
      <template slot="price" slot-scope="text, record">
        <div>
          <a-input-number
            :min="0"
            v-if="record.editable && !tableDef.hasOutOrder && !tableDef.isPlan"
            :max="999999999"
            :value="text"
            @change="(e) => handleChange(e, record, 'price')"
          />
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
      <template slot="remark" slot-scope="text, record">
        <div>
          <a-input
            v-if="record.editable && !tableDef.hasOutOrder"
            :placeholder="$t('common_please_input') + $t('page_material_warehousing_remark')"
            :value="text"
            :maxLength="255"
            @change="(e) => handleChange(e.target.value, record, 'remark')"
          />
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
      <template slot="areaId" slot-scope="text, record">
        <div>
          {{ record.areaName }}
        </div>
      </template>
      <template slot="locationId" slot-scope="text, record">
        <div>
          <a-select
            v-if="record.editable && !tableDef.hasOutOrder"
            style="margin: -5px 0;width:100%;"
            :placeholder="$t('please_select') + $t('page_material_warehousing_location')"
            :value="text"
            showSearch
            :dropdownMatchSelectWidth="false"
            :filterOption="false"
            @dropdownVisibleChange="() => getLocationList(record)"
            @search="(value) => changeLocationList(value, record)"
            @change="(e) => handleChangeLocationId(e, record)"
          >
            <template v-for="(item, index) in locationList">
              <a-select-option :key="index" :value="item.id">
                {{ item.warehouseLocationName }}
              </a-select-option>
            </template>
          </a-select>
          <template v-else>
            {{ record.locationName }}
          </template>
        </div>
      </template>
      <template slot="supplierId" slot-scope="text, record">
        <div>
          <a-select
            v-if="record.editable && !tableDef.hasOutOrder"
            style="margin: -5px 0;width:100%;"
            :placeholder="$t('please_select') + $t('supplier')"
            :value="text"
            showSearch
            :dropdownMatchSelectWidth="false"
            :filterOption="false"
            @dropdownVisibleChange="() => getSupplierList(record)"
            @search="(value) => changeSupplierList(value, record)"
            @change="(e) => handleChange(e, record, 'supplierId')"
          >
            <a-select-option v-for="s in supplierList" :key="s.id" :value="s.id">
              {{ s.name }}
            </a-select-option>
          </a-select>
          <template v-else>
            {{ findSupplier(text) }}
          </template>
        </div>
      </template>
      <template slot="testResult" slot-scope="text, record">
        <div>
          <a-select
            v-if="record.editable && record.fileName && !tableDef.hasOutOrder"
            :placeholder="$t('please_select') + $t('page_material_warehousing_testResult')"
            style="margin: -5px 0;width:100%;"
            :value="text"
            @change="(e) => handleChange(e, record, 'testResult')"
          >
            <a-select-option :value="0">
              {{ $t('page_log_management_fail') }}
            </a-select-option>
            <a-select-option :value="1">
              {{ $t('page_log_management_success') }}
            </a-select-option>
          </a-select>
          <template v-else>
            {{
              text === null || text === undefined
                ? ''
                : text == 0
                ? $t('page_log_management_fail')
                : $t('page_log_management_success')
            }}
          </template>
        </div>
      </template>
      <template slot="fileName" slot-scope="text, record">
        <div>
          <a-upload
            :multiple="false"
            v-if="record.editable && !tableDef.hasOutOrder"
            :showUploadList="false"
            :beforeUpload="beforeUpload"
            :customRequest="(e) => handleChangefileName(e, record)"
          >
            <a-button> <a-icon type="upload" /> {{ $t('page_my_document_upload') }} </a-button>
          </a-upload>
          <template v-else>
            {{ text }}
          </template>
        </div>
      </template>
      <template slot="key" slot-scope="key, record">
        <div class="editable-row-operations">
          <span v-if="record.editable">
            <a @click="() => saveTableEdit(key)">{{ $t('save') }}</a>
            <a-divider type="vertical" />
            <a @click="() => cancelTableEdit(key)">{{ $t('cancel') }}</a>
          </span>
          <span v-else>
            <a :disabled="disabled(record)" @click="() => edit(record)">{{ $t('edit') }}</a>
            <a-divider v-if="tableDef.isPlanAdd" type="vertical" />
            <a-popconfirm :title="$t('delete_tips')" @confirm="() => handleDelete(record)">
              <a v-if="tableDef.isPlanAdd" :disabled="disabled(record) || !canAdd"
                >{{ $t('delete') }}
              </a>
            </a-popconfirm>
          </span>
        </div>
      </template>
    </ml-table>
    <a-button
      type="primary"
      v-if="canAddMaterial"
      :disabled="editingKey !== '' || canAddTwo"
      style="width:100%;margin-top: 8px;"
      @click="addMaterial()"
      >{{ $t('page_material_warehousing_add_material') }}</a-button
    >
  </div>
</template>
<script>
import table from './table.js'
import { MaterialServiceProxy } from '@/service-proxies/app-v2/material.service-proxies'
import { ProductionPlanServiceProxy } from '@/service-proxies/app-v2/coproduction.service-proxies'

const msp = new MaterialServiceProxy()
const ppsp = new ProductionPlanServiceProxy()
export default {
  mixins: [table],
  props: {
    areaId: {
      type: String,
      default: ''
    },
    tableDef: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      count: 1,
      loading: false,
      canAddMaterial: true,
      canAdd: true,
      canAddTwo: false,
      cacheData: [], // 物料列表缓存数据
      dataSource: [], // 物料列表
      areaList: [], // 库区列表
      locationList: [], // 库位列表
      supplierList: []
    }
  },
  watch: {
    tableDef: {
      handler() {
        this.dataSource = []
        this.cacheData = []
        this.canAddTwo = false
        if (this.tableDef.hasOutOrder || this.tableDef.selectPlan != '') {
          this.canAdd = false
          this.canAddMaterial = false
        } else {
          this.canAdd = true
          this.canAddMaterial = true
        }
        if (this.tableDef.isPlan) {
          this.getMaterial()
        } else {
          this.getALLMaterial()
        }
      },
      deep: true,
      immediate: true
    },
    dataSource: {
      handler() {
        if (this.tableDef.isPlan && this.dataSource.length > 0) {
          this.canAddTwo = false
        } else if (this.tableDef.isPlan && this.dataSource.length === 0) {
          this.canAddTwo = true
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    getMaterial() {
      this.editingKey = ''
      // 如果入库类型为 成品入库
      ppsp.productMaterials().then((res) => {
        const data = res.find((value) => value.planCode === this.tableDef.selectPlan)
        if (data) {
          msp.getMaterialByCode([data.materialCode]).then((res) => {
            if (res && res.length > 0) {
              const area = this.areaList.find((res) => res.id === this.areaId)
              const value = this.addValue(res[0], 1, area, undefined)
              this.dataSource = [value]
              this.cacheData = JSON.parse(JSON.stringify(this.dataSource))
            }
          })
        }
      })
    },
    addValue(item, index, area, planMaterial) {
      const value = {
        key: index,
        id: item.id,
        materialId: item.id,
        planMaterialId: planMaterial ? planMaterial.id : '',
        barCode: item.barCode,
        materialTypeName: item.typeName,
        materialCode: item.code,
        materialName: item.name,
        batchCode: '',
        isMustCheck: item.isMustCheck,
        materialStandardModel: item.standardModel,
        materialStuff: item.stuff,
        materialUnit: item.unit,
        number: 0,
        totalNum: 0,
        stockInNum: 0,
        price: '',
        remark: '',
        areaId: this.areaId,
        areaName: area.name,
        locationId: '',
        locationName: '',
        testResult: null,
        contentType: '',
        supplierId: '',
        fileName: '',
        fileObjectKey: ''
      }
      return value
    }
  }
}
</script>
<style scoped></style>
